import {ClientApiExtended} from "@app/api/generated/client.api.extended";

export const ApiClient : ClientApiExtended = new  ClientApiExtended(process.env.REACT_APP_BASE_URL);
